export default __webpack_public_path__ + "static/media/arduino.e69da2e7.png";